// linkedinAuthHelper.js


export const getLinkedInAuthUrl = (clientId,clientSecret,scope) => {
  
  let redirectUri = process.env.REACT_APP_ADMIN_URL;  
  redirectUri = redirectUri?.replace("//", `//${localStorage.getItem("subdomain")}.`);
  let redirectUris=redirectUri+'/callback'; 
  //const scope = 'email profile w_member_social openid r_basicprofile r_organization_admin r_ads w_organization_social r_ads_reporting r_organization_social rw_organization_admin w_organization_social rw_ads';
  const state = generateRandomStrings(10); // This should be a unique string per request
  return `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUris}&state=${state}&scope=${scope}`;
};



function generateRandomStrings(length = 10){
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}